import React, { useContext, useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import styles from './Header.module.css';
import { Button, Col, Row, Space, Spin, Typography } from 'antd';
import { Link } from 'react-router-dom';
import Lockr from 'lockr';
import { UserContext } from '../Reducers/UserContext';

const { Title, Text } = Typography;

const Head = (props) => {
    const { isLoggedIn, setLogger } = useContext(UserContext);

    const [isAuthLogOut, setIsAuthLogOut] = useState(false);

    const handleLogout = async () => {
        // First, determine how the user is logged in
        const authMethod = isLoggedIn?.user?.authMethod;

        // PATH A: THE USER LOGGED IN WITH AUTH0
        if (authMethod === 'auth0') {
            // Set the loading state to show the spinner overlay
            setIsAuthLogOut(true);

            Lockr.flush();
            setLogger({
                active: false,
                user: { role: 'guest', auth0LogOut: true },
            });
        } else {
            Lockr.flush();
            setLogger({
                active: false,
                user: { role: 'guest', auth0LogOut: false },
            });
        }
    };

    // If logging out (specifically via Auth0), show the spinner overlay
    if (isAuthLogOut) {
        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    zIndex: 9999,
                }}
            >
                <Spin size="large" tip="Logging Out..." />
            </div>
        );
    }

    return (
        <div className={styles.site_page_header_ghost_wrapper}>
            <div style={{ backgroundColor: '#555559', height: '60px' }}>
                <Row>
                    {/* <Col span={1}></Col> */}
                    <Col span={7}>
                        <br />{' '}
                        <Row>
                            <Space>
                                <Col>
                                    <div>
                                        <img src="/img/netskope-logo-white.svg" alt="" width="150px" height="30px" />
                                    </div>
                                </Col>
                                <Col>
                                    <Text
                                        style={{
                                            color: 'whitesmoke',
                                            marginTop: '2px',
                                            right: '10px',
                                            fontSize: '14px',
                                        }}
                                        type="secondary"
                                    >
                                        {isLoggedIn['user']['name'] ? '(' + isLoggedIn['user']['name'] + ')' : ''}
                                    </Text>
                                </Col>
                            </Space>
                        </Row>
                    </Col>
                    <Col span={16}></Col>
                    <Col span={1}>
                        <Button
                            type="primary"
                            size="small"
                            style={{ marginTop: '15px', right: '10px' }}
                            onClick={handleLogout}
                            // disabled={!isLoading}
                            // onClick={() => {
                            //     Lockr.flush();
                            //     setLogger({
                            //         active: !isLoggedIn['active'],
                            //         user: '',
                            //     });
                            // }}
                        >
                            Logout
                        </Button>
                    </Col>
                </Row>
            </div>
            <Row>
                <Col span={15}>
                    <Title
                        level={2}
                        style={{
                            color: '#242424',
                            paddingLeft: '40px',
                            paddingTop: '24px',
                            margin: '0px',
                            paddingBottom: '2px',
                            fontFamily: 'PingFangHK-Thin',
                            fontSize: '32px',
                            fontStyle: 'normal',
                            fontWeight: 300,
                            // lineHeight: "40px",
                        }}
                    >
                        <>Product Change Notification</>
                    </Title>
                </Col>

                <Col
                    span={8}
                    style={{
                        paddingTop: '26px',
                    }}
                >
                    <div
                        style={{
                            float: 'right',
                        }}
                    >
                        <Button
                            style={{
                                backgroundColor: '#3397c9',
                                color: 'white',
                                margin: '0px',
                                paddingBottom: '2px',
                            }}
                        >
                            <Link to="/subscribe">Subscribe</Link>
                        </Button>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Head;
